import { TypesenseProductsDocument } from 'shared-code/typesense/typesense.types'
import { DSCompareProductScoresScore } from 'shared-definitions/types'

export function compareProductScoreMapper(
  input: TypesenseProductsDocument
): DSCompareProductScoresScore {
  return {
    id: input.id,
    title: input.name,
    values: input.primary_scores.reduce((acc, score) => {
      const pvValue = score.float_casted_to_int ? score.value / 100 : score.value
      acc[score.id.toString()] = pvValue
      return acc
    }, {} as Record<string, number>),
  }
}
